import { useLocation } from 'react-router-dom';

export const useFromQueryParam = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('from');
};